module.exports = __webpack_public_path__ + "img/11.5e5375e1.png";